export interface ToGlobalPositionParams {
  localPosition: number;
  offset: number;
  localSize: number;
  globalSize: number;
  zoom: number;
}

export const toGlobalPosition = ({
  localPosition,
  offset,
  localSize,
  globalSize,
  zoom,
}: ToGlobalPositionParams): number => {
  return (
    (localPosition - localSize / 2) / zoom + (globalSize / 2 + offset / zoom)
  );
};
